import React from "react";
import "../styles/User.css";

const User = () => {
  return <div>User</div>;
};

export default User;
